import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const getInventoryApi = createApi({
  reducerPath: "getInventoryApi",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    getAllMasterInventory: builder.query({
      query: () => ({
        url: "v1/inventory/master-inventory/",
        method: "GET",
      }),
    }),

    postAllMasterInventory: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/master-inventory/",
        method: "POST",
        body,
      }),
    }),

    patchAllMasterInventory: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/inventory/master-inventory/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    deleteAllMasterInventory: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/master-inventory/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    getAllMasterParts: builder.query({
      query: () => ({
        url: "v1/inventory/master-part/",
        method: "GET",
      }),
    }),

    postAllMasterParts: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/master-part/",
        method: "POST",
        body,
      }),
    }),

    getAllInventory: builder.query({
      query: () => ({
        url: "v1/inventory/inventory/",
        method: "GET",
      }),
    }),

    postAllInventory: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/inventory/",
        method: "POST",
        body,
      }),
    }),

    updateAllInventory: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/inventory/inventory/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    deleteInventory: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/inventory/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    bulkUploadParts: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/bulk-upload/",
        method: "POST",
        body,
      }),
    }),

    bulkkUploadParts: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/bulkk-upload/",
        method: "POST",
        body,
      }),
    }),

    getAllBulkUploadData: builder.query({
      query: () => ({
        url: "v1/inventory/bulk-upload/history/",
        method: "GET",
      }),
    }),

    createInventory: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/vendor-invoice/",
        method: "POST",
        body,
      }),
    }),

    getInventory: builder.query({
      query: () => ({
        url: `v1/inventory/aggregated-inventory/`,
        method: "GET",
      }),
    }),

    hsnBasedInventory: builder.query({
      query: (hsnCode) => ({
        url: `v1/inventory/aggregated-inventory/?hsnCode=${hsnCode}`,
        method: "GET",
      }),
    }),

    serviceRequest: builder.query({
      query: (id) => ({
        url: `v1/gc/booking-requests/?workshop_id=${id}`,
        method: "GET",
      }),
    }),

    adjustedInventory: builder.query({
      query: () => ({
        url: "v1/inventory/adjust-stock/",
        method: "GET",
      }),
    }),

    adjustInventory: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/adjust-stock/",
        method: "POST",
        body,
      }),
    }),

    createLabor: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/master-labor/",
        method: "POST",
        body,
      }),
    }),

    getLabor: builder.query({
      query: () => ({
        url: "v1/inventory/master-labor/",
        method: "GET",
      }),
    }),

    updateLabor: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/master-labor/",
        method: "PATCH",
        body,
      }),
    }),

    deleteLabor: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/master-labor/?labour_id=${id?.id}`,
        method: "DELETE",
      }),
    }),

    suggestedInventoryName: builder.query({
      query: (name) => {
        let finalName = name;
        if (typeof name === "object" && name !== null) {
          finalName = Object.values(name)[0]; // ✅ extract 'hf'
        }
        return {
          url: `v1/inventory/suggestions/?q=${finalName}`,
          method: "GET",
        };
      },
    }),

    // Repair

    getRepairDetails: builder.query({
      query: () => ({
        url: "v1/inventory/order-repair/",
        method: "GET",
      }),
    }),

    createRepairOrder: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/order-repair/",
        method: "POST",
        body,
      }),
    }),

    // Service Master
    getServiceMasterDetails: builder.query({
      query: ({ id, currentpage }) => {
        console.log('getServiceMasterDetails params:', { id, currentpage });
        return {
          url: `v1/gc/service-masters/${id ? `?workshop=${id}&page=${currentpage || 1}` : ''}`,
          method: "GET",
        };
      },
    }),

    homePage: builder.query({
      query: () => ({
        url: "/v1/gc/home/",
        method: "GET",
      }),
    }),

    createServiceMaster: builder.mutation({
      query: (body) => ({
        url: "v1/gc/service-masters/",
        method: "POST",
        body,
      }),
    }),

    updateServiceMaster: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/gc/service-masters/${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteServiceMaster: builder.mutation({
      query: (id) => ({
        url: `v1/gc/service-masters/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    searchVendor: builder.query({
      query: (name) => ({
        url: `/v1/inventory/vendor-suggestions/?q=${name}`,
        method: "GET",
      }),
    }),

    // Appointment

    getAppointment: builder.query({
      query: ({ id, status }) => ({
        url: `v1/gc/workshop-booking-requests/appointment-list/?workshop_id=${id}&status=${status}`,
        method: "GET",
      }),
    }),
    getWorkshopAppointment: builder.query({
      query: ({ 
        id, 
        status, 
        page, 
        page_size, 
        search,
        from_date,
        to_date,
        workshop_id
      }) => {
        const params = new URLSearchParams();
        
        // Add pagination
        params.append('page', page.toString());
        params.append('page_size', page_size.toString());
        
        // Add filters if they exist
        if (id) params.append('workshop_id', id);
        if (status) params.append('status', status);
        if (search) params.append('search', search);
        if (from_date) params.append('from_date', from_date);
        if (to_date) params.append('to_date', to_date);
        if (workshop_id) params.append('workshop_id', workshop_id);
        
        return {
          url: `v1/gc/workshop-booking-requests/admin-appointment-list/?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    getWorkshopPendingAppointment: builder.query({
      query: ({ 
        id, 
        status, 
        page, 
        page_size, 
        search,
        from_date,
        to_date,
        workshop_id
      }) => {
        const params = new URLSearchParams();
        
        // Add pagination
        params.append('page', page.toString());
        params.append('page_size', page_size.toString());
        
        // Add filters if they exist
        if (id) params.append('workshop_id', id);
        if (status) params.append('status', status);
        if (search) params.append('search', search);
        if (from_date) params.append('from_date', from_date);
        if (to_date) params.append('to_date', to_date);
        if (workshop_id) params.append('workshop_id', workshop_id);
        
        return {
          url: `v1/gc/workshop-booking-requests/admin-booking-request-list/?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    cancelAppointment: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/gc/workshop-booking-requests/${id}/cancel-appointment/`,
        method: "POST",
        body,
      }),
    }),

    rescheduleAppointment: builder.mutation({
      query: ({ id, body }) => {
        console.log(id, "dscdscsdcscsc");
        return {
          url: `v1/gc/workshop-booking-requests/${id}/reschedule-appointment/`,
          method: "POST",
          body,
        };
      },
    }),

    confirmAppointment: builder.mutation({
      query: ({ id, body }) => {
        console.log(id, "dscdscsdcscsc");
        return {
          url: `v1/gc/workshop-booking-requests/${id}/confirm-appointment/`,
          method: "POST",
          body,
        };
      },
    }),

    completeAppointment: builder.mutation({
      query: ({ id, body }) => {
        console.log(id, "dscdscsdcscsc");
        return {
          url: `v1/gc/workshop-booking-requests/${id}/complete-appointment/`,
          method: "POST",
          body,
        };
      },
    }),

    getFeedback: builder.query({
      query: () => ({
        url: `v1/gc/admin/workshop-feedback/`,
        method: "GET",
      }),
    }),

    confirmFeedback: builder.mutation({
      query: (body) => {
        return {
          url: `v1/gc/admin/workshop-feedback/bulk-select/`,
          method: "POST",
          body,
        };
      },
    }),

    getWhatsappConfig: builder.query({
      query: ({}) => {
        return {
          url: `v1/gc/whatsapp-config-api/`,
          method: "GET",
        };
      },
    }),

    whatsappConfig: builder.mutation({
      query: (body) => {
        return {
          url: `v1/gc/whatsapp-config-api/`,
          method: "POST",
          body,
        };
      },
    }),

    updateWhatsappConfig: builder.mutation({
      query: ({body,id}) => {
        return {
          url: `v1/gc/whatsapp-config-api/${id}`,
          method: "PATCH",
          body,
        };
      },
    }),

    getEmailConfig: builder.query({
      query: ({}) => {
        return {
          url: `v1/gc/email-config-api/`,
          method: "GET",
        };
      },
    }),

    emailConfig: builder.mutation({
      query: (body) => {
        return {
          url: `v1/gc/email-config-api/`,
          method: "POST",
          body,
        };
      },
    }),

    updateEmailConfig: builder.mutation({
      query: ({body,id}) => {
        return {
          url: `v1/gc/email-config-api/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useConfirmFeedbackMutation,
  useGetFeedbackQuery,
  useServiceRequestQuery,
  useUpdateServiceMasterMutation,
  useSearchVendorQuery,
  useHomePageQuery,
  useDeleteServiceMasterMutation,
  useCreateServiceMasterMutation,
  useGetServiceMasterDetailsQuery,
  useGetAllMasterInventoryQuery,
  usePostAllMasterInventoryMutation,
  usePatchAllMasterInventoryMutation,
  useDeleteAllMasterInventoryMutation,
  useGetAllMasterPartsQuery,
  usePostAllMasterPartsMutation,
  useGetAllInventoryQuery,
  usePostAllInventoryMutation,
  useUpdateAllInventoryMutation,
  useDeleteInventoryMutation,
  useBulkUploadPartsMutation,
  useGetAllBulkUploadDataQuery,
  useBulkkUploadPartsMutation,
  useCreateInventoryMutation,
  useGetInventoryQuery,
  useAdjustedInventoryQuery,
  useCreateLaborMutation,
  useGetLaborQuery,
  useUpdateLaborMutation,
  useDeleteLaborMutation,
  useAdjustInventoryMutation,
  useSuggestedInventoryNameQuery,
  useCreateRepairOrderMutation,
  useGetRepairDetailsQuery,
  useHsnBasedInventoryQuery,

  // Appointment
  useGetAppointmentQuery,
  useCancelAppointmentMutation,
  useRescheduleAppointmentMutation,
  useConfirmAppointmentMutation,
  useCompleteAppointmentMutation,
  useGetWorkshopAppointmentQuery,
  useGetWorkshopPendingAppointmentQuery,

  //Config
  useGetWhatsappConfigQuery,
  useWhatsappConfigMutation,
  useUpdateWhatsappConfigMutation,

  useGetEmailConfigQuery,
  useEmailConfigMutation,
  useUpdateEmailConfigMutation,
} = getInventoryApi;